import { FormControl, Validators, ValidatorFn } from '@angular/forms';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';

export class ArrayUtils {

	public static groupBy(value: any[], field: string): Array<{ key: string, value: any[] }> {
		let groups = ArrayUtils.groupByAsDictionary<any>(value, field);
		return Object.keys(groups).map(key => ({ key, value: groups[key] }));
	}

	public static groupByAsDictionary<TType>(value: TType[], field: string): { [key: string]: TType[] } {
		let groups: { [key: string]: TType[] } = {};

		for (let v of value) {
			let key = v[field];
			if (!groups[key]) {
				groups[key] = [v];
			}
			else {
				groups[key].push(v);
			}
		}

		return groups;
	}

	public static groupByAsMultiArray(value: any[], field: string): Array<Array<any>> {
		let groups: { [key: string]: any } = {};
		let result: Array<Array<any>> = [];
		let i = 0;

		for (let v of value) {
			let key = v[field];
			if (groups[key] == null) {
				groups[key] = i;
				++i;
			}

			let idx = groups[key];
			if (!Array.isArray(result[idx])) {
				result[idx] = new Array<any>();
			}

			result[idx].push(v);
		}

		return result;
	}
}

export class StringUtils {
	/**
	 * Converts first the alphabetic character in a string to uppercase.
	 * @param input A string.
	 */
	public static firstToUppperCase(input: string): string {
		return input.charAt(0).toUpperCase() + input.slice(1);
	}

	/**
	 * Converts first the alphabetic character in a string to lowercase.
	 * @param input A string.
	 */
	public static firstToLowerCase(input: string): string {
		return input.charAt(0).toLowerCase() + input.slice(1);
	}
}

export class ConvertUtils {
	public static asBoolean(value: string): boolean {
		return (value == 'true' || value == '1');
	}

	public static asNumberList(value: string, separator: string = ','): number[] {
		return value
			.split(separator)
			.map(s => ConvertUtils.asNumber(s))
			.filter(s => s != null);
	}

	public static asNumber(value: string, def: number = null): number | null {
		let n = +value;

		if (isNaN(n)) {
			return def;
		}

		return n;
	}

	public static asDate(date: string): Date | null {
		try {
			return new Date(date);
		}
		catch (e) {
			console.warn(e);
			return null;
		}
	}
}

export class BrowserUtils {
	public static isBrowser() {
		return isPlatformBrowser(PLATFORM_ID);
	}

	public static isServer() {
		return isPlatformServer(PLATFORM_ID);
	}
}

export class NumberUtils {

	public static toFixedNumber(value: number, decimalLimit?: number) {
		const integer = NumberUtils._getIntPart(value);
		if (decimalLimit < 1) {
			return integer;
		}

		const decimal = this._getDecimalPart(value, decimalLimit);

		return this._makeNumber(integer, decimal, decimalLimit);
	}

	private static _makeNumber(int: number, dec: number, decimalLimit: number): number {
		if (decimalLimit < 1) {
			return int;
		}

		const max = Math.pow(10, decimalLimit);
		if (max < 1) {
			return int;
		}

		let result = Math.floor((int * max) + dec) / max;

		return result;
	}

	private static _getIntPart(value: number): number {
		return Math.floor(value);
	}

	private static _getDecimalPart(value: number, decimalLimit: number): number {
		if (decimalLimit < 1) {
			return 0;
		}

		const max = Math.pow(10, decimalLimit);
		if (max < 1) {
			return 0;
		}

		const int = Math.floor(value);
		const dec = Math.floor(Math.fround((value - int) * max));

		return dec;
	}
}

export class FlagUtils {
	public static hasFlag(flag: number, value: number): boolean {
		return (flag & value) == value;
	}
	public static setFlag(flag: number, value: number): number {
		return flag ^ value;
	}
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/core/utils.ts